/** 安全解析 JSON 字符串 */
export function safeJsonParse<T>(jsonStr: string | undefined | null, defaultValue: T = {} as T): T {
  if (!jsonStr || typeof jsonStr !== 'string') {
    return defaultValue;
  }
  try {
    return JSON.parse(jsonStr) as T;
  } catch (e) {
    return defaultValue;
  }
}
